<template>
    <transition name="modal-fade">
        <div id="modalEditBanner" class="dibble-modal" style="z-index: 9999">
            <div class="modal small-m">
                <div
                    class="modal-dialog modal-form "
                    role="document"
                    style="width: 600px"
                >
                    <div class="modal-content"
                         style="min-width: 600px !important;">
                        <div class="modal-header">
                            <p class="title-modal"
                               v-text="(data ? 'Edit' : 'Add New') + ' Question'"></p>
                            <button
                                type="button"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click="closeModal"
                            >
                                <img src="@/assets/images/close-dialog.svg"
                                     alt="close-icon">
                            </button>
                        </div>
                        <div class="modal-body form-box mt-2">
                            <div class="user-modal-content"
                                 style="overflow: visible">
                                <div class="row mt-2 pl-2 pr-2">
                                    <div class="col-md-12">
                                        <TextareaField
                                            v-model="text"
                                            name="text"
                                            label="Question Text"
                                            rows="5"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="mt-3">
                                <div class="d-flex justify-content-center">
                                    <button v-if="!data" v-text="'Save'"
                                            class="btn-dialog btn-sm ok-btn"
                                            :disabled="!text"
                                            @click="create">
                                    </button>
                                    <button v-else v-text="'Save'"
                                            class="btn-dialog btn-sm ok-btn"
                                            :disabled="!text"
                                            @click="update">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import TextareaField from "@/commons/FormElements/TextareaField.vue";
import DibbleApi from "@/api";
import DibbleJs from "@/dibble";

export default {
    name: "ModalAddEditCampaignQuestion",
    components: {TextareaField},
    props: {
        campaignId: String,
        data: {
            type: Object,
            default: null
        },
        types: Array
    },
    data() {
        return {
            text: '',
        }
    },
    created() {
        if (this.data) {
            this.text = this.data.question_text;
        }
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        create() {
            const params = {
                '#request': DibbleApi.api.campaignSetQuestion,
                campaign_id: this.campaignId,
                question_text: this.text,
            }

            DibbleJs.showLoader();
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Create question successfully');
                    this.$emit('success')
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        update() {
            const params = {
                '#request': DibbleApi.api.campaignUpdateQuestion,
                campaign_id: this.campaignId,
                question_id: this.data.question_id,
                question_text: this.text,
            }

            DibbleJs.showLoader();
            DibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    DibbleJs.toastSuccessMessage('Update question successfully');
                    this.$emit('success')
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-content {
    min-width: 500px !important;
}

.modal-content, .modal-body {
    background: #EDF5F7 !important;
    border-radius: 60px !important;
    padding: 10px 20px;
}

.modal-header {
    display: flex !important;
    justify-content: space-between !important;
    align-items: center;
    padding: 10px 0px !important;
    border-bottom: 1.5px solid #1C5169;
    margin: 0 20px !important;

    .title-modal {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 22px;
        line-height: 22px;
        letter-spacing: 0.01em;
        color: #1C5169;
        margin-top: 0 !important;
    }

    button {
        border: none !important;
        outline: none !important;
        background: initial;
    }
}

.user-modal-content {
    max-height: 500px;
    overflow: scroll;
}

.btn-dialog.btn-sm {
    font-size: 14px;
    height: 40px;
}

.donation-checkbox {
    .checkbox-item {
        display: flex;
    }

    .checkbox-custom {
        position: inherit;
        width: 40px;
        height: 40px;

        .checkmark-new {
            border-radius: 5px;
            background: #41B8DC;

            &.not-active {
                background: #dde6e9;
            }
        }
    }

    p {
        color: #555E67;
    }
}
</style>
